import React from 'react'
import { Layout } from '@/components/template/layout'
import { useTranslation } from 'react-i18next'
import { JaContent } from '@/components/organisms/securityPolicy/ja-content'
import { EnContent } from '@/components/organisms/securityPolicy/en-content'
import { KoContent } from '@/components/organisms/securityPolicy/ko-content'
import { ZhContent } from '@/components/organisms/securityPolicy/zh-content'
import { ZhTwContent } from '@/components/organisms/securityPolicy/zh-tw-content'
import { useQuerySearchParams } from '@/hooks/use-query-search-params'
import { StaticLayout } from '@/components/template/static-layout'

export const SecurityPolicy: React.FC = () => {
  const {
    i18n: { language },
  } = useTranslation()

  const { hotelId } = useQuerySearchParams<{ hotelId?: string }>()

  const contents = {
    ja: <JaContent />,
    en: <EnContent />,
    ko: <KoContent />,
    zh: <ZhContent />,
    zhTw: <ZhTwContent />,
  }

  return hotelId ? <Layout>{contents[language]}</Layout> : <StaticLayout>{contents[language]}</StaticLayout>
}
